import { FC } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import LatexText from 'components/LatexText/LatexText';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline',
    wordBreak: 'break-word',
    '& .katex-display': {
      margin: theme.spacing(0.5, 0),
      overflowX: 'auto',
      overflowY: 'hidden',
    },
  },
}));

type OnGoLatexTextProps = {
  text: string;
  className?: string;
  hideIncompleteMath?: boolean;
};

/** Renders On Go dynamic copy (answers, explanations) with embedded LaTeX. */
const OnGoLatexText: FC<OnGoLatexTextProps> = ({ text, className, hideIncompleteMath = false }) => {
  const classes = useStyles();

  return (
    <span className={clsx(classes.root, className)}>
      <LatexText hideIncompleteMath={hideIncompleteMath} text={text} />
    </span>
  );
};

export default OnGoLatexText;
